import Veraportal from "./Veraportal";
import {IPortalseite} from "./Interfaces";

export default class Gruppenverwaltung extends Veraportal implements IPortalseite {
    override async onSeiteLoad(): Promise<boolean> {

        return true;
    }

    override async onSeiteFinished(): Promise<boolean> {

        return true;
    }

    override async onSeiteLeave(): Promise<boolean> {

        return true;
    }
}